import { Component, OnInit, TemplateRef, ViewChild, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { ChangePasswordDTO, UserDTO } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { DialogService } from '../../services/dialog.service';
import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  //@HostBinding('class') className='';
 //get themeMode(){
 //   return GlobalService.getSelectedThemes;
  //}
  passwordForm: UntypedFormGroup;
  submitted = false;

  mobile = false;

  userConnected : UserDTO;
  oldPassword : string;
  newPassword : string;
  repeatedNewPassword : string;
  currentThemesLabel:string; 
  
  @ViewChild('modalChangePassword', {static: true}) modalChangePassword : TemplateRef<any>;
  modalChangePasswordRef : MatDialogRef<TemplateRef<any>>

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private dialog : MatDialog,
    private authService : AuthService,
    private userService : UserService,
    public translate : TranslateService,
    private Service: GlobalService
    ) { }

    sendMessage(): void {
      // send message to subscribers via observable subject
      this.Service.sendUpdate('Message from Sender Component to Receiver Component!');
  }

@Output()
  ngOnInit(): void {

    this.userConnected = this.authService.getCurrentUser();

    this.passwordForm = this.formBuilder.group({
      oldPassword: [this.oldPassword, Validators.required],
      newPassword: [this.newPassword, Validators.required],
      repeatedNewPassword: ['', Validators.required]
    },
    {
      validator: this.MustMatch('newPassword', 'repeatedNewPassword')
    }
    );

    if (window.screen.width <= 480) {
      this.mobile = true;
    }
    
    this.currentThemesLabel = this.userConnected.IsDarkMode? this.translate.instant("GENERIC_LABEL.DARK_MODE"):this.translate.instant("GENERIC_LABEL.LIGHT_MODE");
        
  }

  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      //Se ci sono già errori non c'è bisogno di controllare altro
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }
      //Se la validazione fallisce imposto l'errore a true
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }
  toggleDarkTheme(checked: boolean) {
    this.userConnected.IsDarkMode=checked
    this.currentThemesLabel = checked? this.translate.instant("GENERIC_LABEL.DARK_MODE"):this.translate.instant("GENERIC_LABEL.LIGHT_MODE");
    this.userService.setThemes(this.userConnected.ID, checked).then((res) => {
      this.authService.setCurrentToken(res.Value);
      this.Service.sendUpdate('changethemes')

    });
    //window.location.reload()
  }
  /**
   * Per accedere ai campi del form facilmente
   */
  get f() {
    return this.passwordForm.controls;
  }

  /**
   * Al click del pulsante "Salva" invio le modifiche
   * del profilo utente al server
   */
  onSubmit() {
    this.submitted = true;

    // Se il form non è valido mi fermo
    if (this.passwordForm.invalid) {
      return;
    }
  }

  openModalChangePassword(){
    this.modalChangePasswordRef = this.dialog.open(this.modalChangePassword, {
      disableClose: false,
      hasBackdrop: true,
      minHeight: '30%',
      minWidth: '40%'
    });

    this.modalChangePasswordRef.afterClosed().subscribe(() => {
      this.passwordForm.reset();
      this.newPassword = "";
      this.oldPassword = "";
      this.repeatedNewPassword = "";
    })
  }

  exitModal(){
    this.modalChangePasswordRef.close();
  }

  savePassword(){
    let dto : ChangePasswordDTO = new ChangePasswordDTO();
    dto.userID = this.userConnected.ID.toString();
    dto.oldPassword = this.oldPassword;
    dto.newPassword = this.newPassword;
    this.userService.changePassword(dto).then(() => {
      DialogService.Success(this.translate.instant("DIALOGS.PASSWORD_MODIFIED_SUCCESS"));
      this.exitModal();
    }).catch(e => {
      DialogService.Error(e.message);
    })
  }

  exit() {
    this.router.navigate(['/dashboard']);
  }


  viewMyNamirialProfile() {    
    window.open(environment.MyNamirialUrl, '_blank');
  }
}
